var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.191 9.2493L20.5078 3.63867C20.124 2.35913 18.969 1.5 17.6338 1.5H6.36621C5.031 1.5 3.87597 2.35913 3.49218 3.63867L1.80898 9.2493C0.746149 9.71118 0 10.7689 0 12V18C0 18.8284 0.671631 19.5 1.5 19.5H1.50009L1.5 20.9999C1.5 21.8284 2.17154 22.5 3 22.5H4.50009C5.32846 22.5 6.00009 21.8284 6.00009 21L5.99945 19.5H18L17.9999 20.9999C17.9999 21.8284 18.6715 22.5 19.4999 22.5H21C21.8285 22.5 22.5 21.8284 22.5 21V19.5001L22.4995 19.5H22.5C23.3284 19.5 24 18.8284 24 18V12C24 10.7689 23.2538 9.71118 22.191 9.2493L22.191 9.2493ZM6.36617 4.5H17.6337L18.9838 9H5.01613L6.36616 4.5H6.36617ZM5.99995 15.75C5.17149 15.75 4.49995 15.0784 4.49995 14.25C4.49995 13.4215 5.17149 12.75 5.99995 12.75C6.82841 12.75 7.49995 13.4215 7.49995 14.25C7.49995 15.0784 6.82841 15.75 5.99995 15.75ZM18 15.75C17.1715 15.75 16.5 15.0784 16.5 14.25C16.5 13.4215 17.1715 12.75 18 12.75C18.8284 12.75 19.5 13.4215 19.5 14.25C19.5 15.0784 18.8284 15.75 18 15.75Z",
    fill: "#FB6910"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.40ec9a6a718c384edcda332e3812ba54.svg";
export { ForwardRef as ReactComponent };